import { useRef, useState } from "react";

import debounce from "lodash/debounce";

import type { InclusionOption } from "app/pages/sales-intelligence/types/commonMaps";

import industryFilterTrackingService from "../services/tracking/industry-filter/trackingService";

type UseIndustrySearchReturnProps = {
    handleSearchChange: (term: string) => void;
    searchTerm: string;
};

/** @deprecated Search state for the legacy industry filter. Superseded by the taxonomy fuzzy search (SI-8780). */
const useIndustrySearch = (type: InclusionOption): UseIndustrySearchReturnProps => {
    const [searchTerm, setSearchTerm] = useState("");

    const valueTypeRef = useRef(type);
    valueTypeRef.current = type;

    const trackSearch = debounce((term: string) => {
        industryFilterTrackingService.trackIndustrySearch(term, valueTypeRef.current);
    }, 300);

    const handleSearchChange = (term: string) => {
        setSearchTerm(term);
        trackSearch(term);
    };

    return { handleSearchChange, searchTerm };
};

export default useIndustrySearch;
